import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "~/components/ui/dialog";

const isMac =
  typeof navigator !== "undefined" && navigator.platform?.includes("Mac");
const mod = isMac ? "\u2318" : "Ctrl";

const shortcuts = [
  { keys: `${mod}+Enter`, description: "Run query" },
  { keys: `${mod}+Shift+F`, description: "Format SQL" },
  { keys: "Escape", description: "Cancel edit / close dialog" },
  { keys: "Tab", description: "Indent in editor" },
  { keys: "Double-click cell", description: "Edit cell value" },
  { keys: "Enter", description: "Save cell edit" },
  { keys: `${mod}+Enter`, description: "Save long text edit" },
  { keys: "Tab", description: "Save cell and move to next" },
];

export function ShortcutsDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
          <DialogDescription>
            Available shortcuts in the database editor.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border/50">
                <th className="text-left py-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                  Shortcut
                </th>
                <th className="text-left py-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {shortcuts.map((s, i) => (
                <tr
                  key={i}
                  className="border-b border-border/30 last:border-0"
                >
                  <td className="py-2 pr-4">
                    <kbd className="inline-flex items-center gap-0.5 rounded border border-border bg-muted px-1.5 py-0.5 text-xs font-mono text-muted-foreground">
                      {s.keys}
                    </kbd>
                  </td>
                  <td className="py-2 text-[13px] text-foreground">
                    {s.description}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
